import { api, fetchAll } from '.'
import { enumLabel } from '@/utils/labels'

// Listes de référence pour les menus déroulants : chargées une fois (toutes
// les pages), puis mises en cache jusqu'à la prochaine modification.

const vehicleLabel = (v) =>
  [v.registration_number, [v.brand, v.model].filter(Boolean).join(' ')].filter(Boolean).join(' · ')

const DEFINITIONS = {
  vehicles: { load: () => fetchAll(api.vehicles.list, { sort: 'registration_number' }), label: vehicleLabel },
  drivers: { load: () => fetchAll(api.drivers.list, { sort: 'name' }), label: (d) => d.name },
  owners: { load: () => fetchAll(api.owners.list, { sort: 'name' }), label: (o) => o.name },
  vehicleTypes: { load: () => fetchAll(api.vehicleTypes.list, { sort: 'name' }), label: (t) => t.name },
  expenseCategories: { load: () => fetchAll(api.expenseCategories.list, { sort: 'name' }), label: (c) => c.name },
  maintenancePlans: { load: () => fetchAll(api.maintenancePlans.list, { sort: 'name' }), label: (p) => p.name },
  users: { load: () => fetchAll(api.users.list, { sort: 'name' }), label: (u) => u.name },
  roles: {
    load: () => api.roles.list(),
    value: (r) => r.name,
    label: (r) => enumLabel('role', r.name)
  }
}

const cache = new Map()

export function loadLookup(key, { onlyWhere } = {}) {
  const def = DEFINITIONS[key]
  if (!def) return Promise.reject(new Error(`Liste de référence inconnue : ${key}`))
  if (!cache.has(key)) {
    const promise = def.load().catch((e) => {
      cache.delete(key)
      throw e
    })
    cache.set(key, promise)
  }
  return cache.get(key).then((rows) =>
    rows
      .filter((row) => (onlyWhere ? onlyWhere(row) : true))
      .map((row) => ({ value: def.value ? def.value(row) : row.id, label: def.label(row), raw: row }))
  )
}

export function clearLookups() {
  cache.clear()
}
